import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {
  messages = {
    "200": "",
    "404": "Your special identifier is not found! Please use the link provided in your invitation message!",
    "409": "This annual review has already been completed.",
    "503": "The digital wallet service is currently unavailable"
  }

  mapping = new Map(Object.entries(this.messages));
  message = '';
  code = '200';
  memberId = null;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {
    this.code = this.route.snapshot.paramMap.get('status') || '200';
    this.message = this.mapping.get(this.code) || '';

    this.memberId = this.localStorageService.getItem("renewal")?.DigitalWalletCard_ID;
  }

  downloadCard(): void {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    if (this.memberId) {
      let fileUrl = '';

      if (isIOS) {
        fileUrl = `https://pub2.pskt.io/${this.memberId}.gpay`;
        // redirect on iOS
        window.location.href = fileUrl;
      } else if (isAndroid) {
        fileUrl = `https://pub2.pskt.io/${this.memberId}.pkpass`;
        // redirect on Android
        window.location.href = fileUrl;
      } else {
        // Desktop → open popup window
        fileUrl = `https://pub2.pskt.io/${this.memberId}.pkpass`;
        window.open(fileUrl, '_blank');
      }
    }
  }
}
